import { supabase } from "../supabase";

// Public key only — safe to ship to the client. The matching private key
// lives only in the Supabase Edge Function that sends pushes.
const VAPID_PUBLIC_KEY =
  "BJIFgdA_wCFf6Xe7D3wqAAQBi8uL_EbTyelvGSHb67FAr6rgPtvAhqsms4JUx925bnGbQ4yYEX7PJ98fGMFSEys";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i++) outputArray[i] = rawData.charCodeAt(i);
  return outputArray;
}

export function isPushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export async function isPushSubscribed() {
  if (!isPushSupported()) return false;

  const reg = await navigator.serviceWorker.getRegistration();
  if (!reg) return false;

  const sub = await reg.pushManager.getSubscription();
  return !!sub;
}

export async function enablePush(userId) {
  if (!isPushSupported()) {
    return { error: new Error("Push notifications aren't supported on this browser.") };
  }

  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    return { error: new Error("Notification permission was not granted.") };
  }

  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY)
  });

  const json = sub.toJSON();

  const { error } = await supabase.from("push_subscriptions").upsert(
    {
      user_id: userId,
      endpoint: json.endpoint,
      p256dh: json.keys.p256dh,
      auth: json.keys.auth
    },
    { onConflict: "endpoint" }
  );

  return { error };
}

export async function disablePush() {
  if (!isPushSupported()) return { error: null };

  const reg = await navigator.serviceWorker.getRegistration();
  if (!reg) return { error: null };

  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    await supabase.from("push_subscriptions").delete().eq("endpoint", sub.endpoint);
    await sub.unsubscribe();
  }

  return { error: null };
}
